import React, { FC } from "react";
import { ActivityLogT } from "../../models/models";
import Icon from "../Icon/Icon";
import dayjs from "dayjs";
import { DATE_FORMAT } from "../../utils/constants";
import { ActivityLogEntryModeE } from "../../models/enums";
import { useTranslate } from "../../utils/hooks/useTranslate";

import styles from "./activityLogRow.module.scss";
import { Span } from "../Text/Text";

type ActivityLogRowPropTypes = {
  item: ActivityLogT;
};

const ActivityLogRow: FC<ActivityLogRowPropTypes> = (props) => {
  const {
    item: {
      ActivityDateTime,
      UserFullName,
      ClientName,
      ModeName,
      RejectedFileAdId,
      ModeNumber,
    },
  } = props;
  const { t } = useTranslate();

  return (
    <div className={styles.wrapper}>
      <Icon name="reset" className={styles.icon} />
      <div className={styles.dataWrapper}>
        <span>{dayjs(ActivityDateTime).format(`${DATE_FORMAT} HH:mm:ss`)}</span>
        <span>{UserFullName}</span>
        <span>{ClientName}</span>
        <Span>
          {RejectedFileAdId &&
          ModeNumber === ActivityLogEntryModeE.RejectedByBroadcaster
            ? t(`Version ${RejectedFileAdId} was declined by broadcaster`)
            : t(ModeName)}
        </Span>
      </div>
    </div>
  );
};

export default ActivityLogRow;
